import { getApplicationsByType, getApplicationType } from "../helpers";
import { RydeAdminUnit, RydeUiUnit } from "../models";

export const isEntityGlobal = (entity: RydeUiUnit): boolean => {
  return checkEntityGlobal(entity);
};

const checkEntityGlobal = (entity: RydeUiUnit): boolean => {
  const { isAdminApp } = getApplicationsByType(getApplicationType());

  const globalEntities: Record<RydeAdminUnit, boolean> = {
    adminAction: true,
    adminTools: true,
    alertConfiguration: false,
    apiKey: true,
    auditLog: true,
    backup: true,
    process: false,
    busStation: true,
    mapCacheStat: true,
    company: true,
    customField: true,
    entity: true,
    etlJobLog: true,
    etlSchedule: true,
    fieldType: true,
    formSchema: true,
    globalConfig: true,
    gridSchema: true,
    language: true,
    messagingLog: true,
    permission: true,
    aiConversation: true,
    providerLog: true,
    report: true,
    role: true,
    supplierQuarantine: true,
    user: true,
    userRole: true,
    webhook: true,
    webhookDelivery: true,
    geoArea: isAdminApp,
  } as const;

  return globalEntities[entity as keyof typeof globalEntities] || false;
};
